import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getUserDetailsService,
  getOnlineUsersService,
  getUsersListService,
  updateUserService,
  updateUserStatusService
} from 'network/services/users.service'

export const fetchAllUsers = createAsyncThunk(
  'userManagement/fetchAllUsers',
  async (data, thunkApi) => {
    try {
      const res = await getUsersListService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const fetchUserDetails = createAsyncThunk(
  'userManagement/fetchUserDetails',
  async (userId, thunkApi) => {
    try {
      const res = await getUserDetailsService(userId)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const updateUser = createAsyncThunk(
  'userManagement/updateUser',
  async ({ payload, onSuccess }, thunkApi) => {
    try {
      const res = await updateUserService(payload)
      onSuccess?.()
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const updateUserStatus = createAsyncThunk(
  'userManagement/updateUserStatus',
  async ({ payload, onSuccess, onComplete }, thunkApi) => {
    try {
      const res = await updateUserStatusService(payload)
      onSuccess?.()
      onComplete?.()
      return res
    } catch (error) {
      onComplete?.()
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const fetchOnlineUsers = createAsyncThunk(
  'userManagement/fetchOnlineUsers',
  async (data, thunkApi) => {
    try {
      const res = await getOnlineUsersService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)
